module.exports = __webpack_public_path__ + "static/media/rhomb.119dcfd7.svg";